import React from "react";
import Card from "@material-ui/core/Card";
import CardActionArea from "@material-ui/core/CardActionArea";
import CardActions from "@material-ui/core/CardActions";
import CardContent from "@material-ui/core/CardContent";
import CardMedia from "@material-ui/core/CardMedia";
import MapIcon from "@material-ui/icons/Map";
import IconButton from "@material-ui/core/IconButton";
import LanguageIcon from "@material-ui/icons/Language";
import { FBIcon, WhatsappIcon, InstagramIcon } from "./icons.js";
import Typography from "@material-ui/core/Typography";
import { distance } from "./geo.js";
import { navigate } from "@reach/router";
import PhoneIcon from "@material-ui/icons/Phone";
import FavoriteIcon from "@material-ui/icons/Favorite";
import FavoriteBorderIcon from "@material-ui/icons/FavoriteBorder";
import MailOutlineIcon from "@material-ui/icons/MailOutline";
import { makeStyles } from "@material-ui/core/styles";
import { categoryChip } from "./listcard.js";
const useStyles = makeStyles({
  root: {
    //maxWidth: 345
  },
  media: {
    height: 200
  },
  cardActions: {
    root: {
      paddingLeft: "16px",
      paddingRight: "16px",
      paddingTop: "8px",
      paddingBottom: "16px",
      flexWrap: "wrap"
    },
    spacing: {
      marginLeft: "0px",
      marginRight: "8px"
    }
  }
});

export function CYTCard(props) {
  const classes = useStyles();
  const categoriesChips =
    props.provider.categories &&
    props.provider.categories.map(categoryName =>
      categoryChip(
        `${categoryName}-${props.id}`,
        categoryName,
        props.onCategoryClick,
        props.selectedCategories &&
          props.selectedCategories.includes(categoryName.toLowerCase())
      )
    );

  var distanceToCurrentGeoposition = null;
  if (props.currentGeopos && props.provider.geopoint) {
    const kms = distance(
      props.currentGeopos.lat,
      props.currentGeopos.lon,
      props.provider.geopoint.latitude,
      props.provider.geopoint.longitude
    );
    if (kms < 1) {
      distanceToCurrentGeoposition = `A ${Math.round(kms * 1000)}mts`;
    } else if (kms < 10) {
      distanceToCurrentGeoposition = `A ${Math.round(kms)}kms`;
    }
  }
  return (
    <Card key={props.provider.id} style={props.style} className={classes.root}>
      <CardActionArea>
        {props.provider.photo && (
          <CardMedia className={classes.media} image={props.provider.photo} />
        )}
        <CardContent>
          <Typography
            gutterBottom
            variant="h5"
            component="h2"
            onClick={e => {
              navigate("/p/" + props.provider.id);
              e.preventDefault();
            }}
          >
            <a
              style={{ color: "inherit", "text-decoration": "none" }}
              href={"/p/" + props.provider.id}
            >
              {props.provider.name}
            </a>
          </Typography>
          <Typography variant="body2" color="textSecondary" component="p">
            {props.provider.what}
          </Typography>
          <br />
          <Typography variant="body2" color="textSecondary" component="p">
            {props.provider.location}
          </Typography>

          {distanceToCurrentGeoposition}
        </CardContent>
        <CardActions>
          <CYTLike
            liked={props.liked}
            onClick={e => props.onClick && props.onClick(e)}
          />
          {props.provider.website_url && (
            <IconButton
              rel="noopener"
              target="_blank"
              href={props.provider.website_url}
            >
              <LanguageIcon />
            </IconButton>
          )}
          {props.provider.instagram_url && (
            <IconButton
              rel="noopener"
              target="_blank"
              href={props.provider.instagram_url}
            >
              <InstagramIcon />
            </IconButton>
          )}

          {props.provider.facebook_url && (
            <FBIcon
              rel="noopener"
              target="_blank"
              href={props.provider.facebook_url}
            />
          )}
          {props.provider.gmaps_url && (
            <IconButton
              target="_blank"
              rel="noopener noreferrer"
              href={props.provider.gmaps_url}
            >
              <MapIcon />
            </IconButton>
          )}
          {props.provider.email && (
            <IconButton
              target="_blank"
              rel="noopener noreferrer"
              href={`mailto:${props.provider.email}`}
            >
              <MailOutlineIcon />
            </IconButton>
          )}
          {props.provider.whatsapp && (
            <WhatsappIcon
              target="_blank"
              rel="noopener noreferrer"
              href={`https://wa.me/${props.provider.whatsapp.replace(
                /[^0-9]/,
                ""
              )}`}
            />
          )}
          {props.provider.telephone && (
            <IconButton
              target="_blank"
              rel="noopener noreferrer"
              href={`tel:${props.provider.phone}`}
            >
              <PhoneIcon />
            </IconButton>
          )}
        </CardActions>
        <CardActions
          classes={{
            root: classes.cardActions.root,
            spacing: classes.cardActions.spacing
          }}
        >
          {categoriesChips}
        </CardActions>
      </CardActionArea>
    </Card>
  );
}

function CYTLike(props) {
  //  type='checkbox' checked={props.liked}
  return (
    <IconButton onClick={e => props.onClick && props.onClick(e)}>
      {props.liked ? <FavoriteIcon /> : <FavoriteBorderIcon />}
    </IconButton>
  );
}
